export default {"src":"/_next/static/media/ROKU.aa7dfb10.svg","height":18,"width":18};